<template>
  <div class="container">
    <div class="top_title"><router-link class="icon_back" :to="{name:'H060010'}" tag="span"></router-link>
      课程资料详细</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="curriculum_records_title" style="margin-top: 2.6rem">
        <span class="icon_curriculum_records"></span>
        <span>课程记录</span>
      </div>
      <div class="curriculum_records">
        <div class="weui-cells item">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>校区</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_SCHOOL_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>班级</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_CLASS_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>上课日期</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_DATE"/>
            </div>
          </div>
        </div>
      </div>

      <div class="instruction_title">
        <span class="icon_instruction"></span>
        <span>说明</span>
      </div>
      <div class="instruction_text">{{info.I_REMARK}}</div>

      <div class="instruction_title">
        <span class="icon_instruction"></span>
        <span>老师备注</span>
      </div>
      <div class="instruction_text">{{info.I_REMARK_TEACHER}}</div>

      <div class="attachments_title">
        <span class="icon_attachments"></span>
        <span>附件</span>
      </div>
      <div class="attachments">
        <div class="weui-cells item">
          <div v-for="item,index in info.dataList" class="weui-cell">
            <div class="weui-cell__bd">
              <p>{{item.I_FILE_SHOW_NAME}}</p>
            </div>
            <div v-if="item.I_FILE_TYPE == '音频'" class="weui-cell__ft">
              <span class="icon_audio" @click="clickAudio(index)"></span>
              <audio :id="'audio_' + index" :src="item.I_FILE_NAME" style="display: none;" loop="loop"></audio>
            </div>
            <div v-if="item.I_FILE_TYPE == '视频'" class="weui-cell__ft">
              <span class="icon_video" @click="clickVideo(item)"></span>
              <!--<video width="100%" height="100%"  :id="'video_' + index" :src="item.I_FILE_NAME"-->
                     <!--style="display: none;"   @ended="myFunction($event)"-->
                     <!--x-webkit-airplay="true" webkit-playsinline="true" x5-video-player-type="h5"></video >-->
            </div>
            <div v-if="item.I_FILE_TYPE == '文件'" class="weui-cell__ft">
              <a :href="item.I_FILE_NAME"><span class="icon_word"></span></a>
            </div>
          </div>
        </div>
      </div>

      <router-link :to="{name:'H060010',params:{pageNo: 'H060020'}}" class="bottom_btn" tag="button">返回</router-link>
    </div>

    <div class="overlayer" >
      <div class="modal">
        <span class="icon_close" @click="closeModal()"></span>
        <div class="modal_contents">
          <video width="100%" height="100%"  id="video" :src="vedioSrc"
                    @ended="myFunction($event)" controls="controls"   x5-video-player-type="h5"></video >
                <!-- x-webkit-airplay="true" webkit-playsinline="true" x5-video-player-type="h5"-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        info: {
          dataList: []
        },
        vedioSrc: "",
      }
    },
    created() {
      let H060020Info = this.$route.params.info
      if(H060020Info) {
        H060020Info = JSON.parse(H060020Info)
        window.localStorage.setItem("H060020", JSON.stringify(H060020Info))
      } else {
        H060020Info = JSON.parse(window.localStorage.getItem("H060020"))
      }

      DataRequestFactory.I060020(H060020Info).then((response) => {
        this.info = response
      })
    },
    methods: {
      clickAudio(index) {
        let audio = document.getElementById('audio_' + index);
        if (audio !== null) {
          if (audio.paused) {
            let audios = $("audio[id^=audio_]");
            for (let i = 0; i < audios.length; i++) {
              audios[i].pause();
            }
            $(".icon_audio.active").removeClass("active")
            $(audio).parent().find('.icon_audio').addClass("active")
            audio.play();// 播放
          } else {
            $(audio).parent().find('.icon_audio').removeClass("active")
            audio.pause();// 暂停
          }
        }
      },
      myFunction(e) {
        $(".overlayer").css("top","300%")
      },
      closeModal() {
        $(".overlayer").css("top","300%")
        let video = document.getElementById('video');
        if (!video.paused) {
          video.pause();
        }
      },
      clickVideo(item) {
        $(".overlayer").css("top","0")
        this.vedioSrc = item.I_FILE_NAME
//        this.vedioSrc = "http://www.w3school.com.cn/i/movie.mp4"
        setTimeout(function() {
          $("video#video")[0].play();
        },500)
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 0
      $(".scroll_area").css("height", heightDiff + "px"   )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H060020.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H060020.vue